import { render, staticRenderFns } from "./CriminalStepFour.vue?vue&type=template&id=607819cd"
import script from "./CriminalStepFour.vue?vue&type=script&lang=js"
export * from "./CriminalStepFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports